import { type SpendProductPurchaseDto } from 'entities/ReportSpendSummary';
import { toNumber } from 'shared/lib/number/number';
import { type ReportWidgetItem } from 'widgets/ComposableReportWidget';

const resolvePurchaseOrderId = (
    order: SpendProductPurchaseDto['order'],
): string | undefined => {
    if (typeof order.orderId === 'string' && order.orderId) {
        return order.orderId;
    }
    if (typeof order.id === 'string' && order.id) {
        return order.id;
    }
    return undefined;
};

export const mapProductPurchasesToWidgetItems = (
    purchases: SpendProductPurchaseDto[],
): ReportWidgetItem[] =>
    purchases.map((purchase, index): ReportWidgetItem => {
        const submittedDate = new Date(purchase.submittedAt);
        const dateLabel = new Intl.DateTimeFormat(undefined, {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
        }).format(submittedDate);
        const orderId = resolvePurchaseOrderId(purchase.order);

        return {
            id: `${orderId ?? purchase.order.orderNumber ?? index}-${
                purchase.supplierId
            }-${index}`,
            label: purchase.order.orderNumber ?? orderId ?? '',
            primaryValue: toNumber(purchase.spend),
            secondaryValues: {
                date: dateLabel,
                orderNumber: purchase.order.orderNumber ?? '',
                propertyName: purchase.propertyName ?? '',
                supplierName: purchase.supplierName,
                quantity: purchase.quantity,
                spend: purchase.spend,
            },
            meta: { orderId },
        };
    });
